<template>
    <div class="panel">
        <div style="display: flex;justify-content: flex-end;margin-bottom: 15px">
            <el-link type="warning" @click="loadData"><i class="el-icon-refresh"></i>刷新数据,实时查看学生交卷状态</el-link>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="primary" @click="exportResults()"><i class="el-icon-download"></i>导出</el-button>

        </div>
        <div class="panel_body">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column min-width="180" prop="name" label="班级名称">
                </el-table-column>
                <el-table-column min-width="180" prop="totalPeopleNumber" label="总人数">
                </el-table-column>
                <el-table-column min-width="180" prop="totalScore" label="总分数">
                </el-table-column>
                <el-table-column min-width="180" prop="avgScore" label="平均分">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
    export default {
        components: {},
        props: [
            "attr"
        ],
        data() {
            return {
                form: {
                    keywords: "",
                    examId: this.attr.examId,
                },
                tableData: [],
            }
        },
        watch: {
            "form": {
                handler: function(newValue) {
                    if (event.keyCode == 32 || event.keyCode == 13) return;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            loadData() {
                let examId = this.form.examId;
                this.$ajaxPost("/exam/classAvgScore/" + examId, {}, (data) => {
                    if (data && data.result && data.success) {
                        this.tableData = data.result;
                    }
                })
            },
            exportResults() {
                let examId = this.form.examId;
                window.open("/exam/exportResults/" + examId + "?token=" + localStorage.getItem("token"));
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
